var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoudspeaker18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 6h5.394a2 2 0 0 0 1.11-.336l3.941-2.628A1 1 0 0 1 16 3.87V14.13a1 1 0 0 1-1.555.832l-3.941-2.627A2 2 0 0 0 9.394 12H9a.72.72 0 0 0-.684.949l.789 2.365A.901.901 0 0 1 8.25 16.5h-.6a1 1 0 0 1-.914-.594L5 12H4a3 3 0 1 1 0-6zm0 2a1 1 0 1 0 0 2h5.713a1 1 0 0 1 .53.152L14 12.5v-7l-3.757 2.348a1 1 0 0 1-.53.152H4z",
    clipRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTQgNmg1LjM5NGEyIDIgMCAwIDAgMS4xMS0uMzM2bDMuOTQxLTIuNjI4QTEgMSAwIDAgMSAxNiAzLjg3VjE0LjEzYTEgMSAwIDAgMS0xLjU1NS44MzJsLTMuOTQxLTIuNjI3QTIgMiAwIDAgMCA5LjM5NCAxMkg5YS43Mi43MiAwIDAgMC0uNjg0Ljk0OWwuNzg5IDIuMzY1QS45MDEuOTAxIDAgMCAxIDguMjUgMTYuNWgtLjZhMSAxIDAgMCAxLS45MTQtLjU5NEw1IDEySDRhMyAzIDAgMSAxIDAtNnptMCAyYTEgMSAwIDEgMCAwIDJoNS43MTNhMSAxIDAgMCAxIC41My4xNTJMMTQgMTIuNXYtN2wtMy43NTcgMi4zNDhhMSAxIDAgMCAxLS41My4xNTJINHoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export { SvgLoudspeaker18 as ReactComponent };